export type SelectionSummary = {
  labelsText: string;
  overflowText?: string;
  ariaText: string;
  allowLabelTruncation: boolean;
};

type TextMeasurer = (text: string) => number;

type LabeledOption = { label: string };

// Pure layout helper: callers provide measured widths so this stays deterministic
// and easy to unit-test outside the browser.
export function selectionSummary(
  selectedOptions: LabeledOption[],
  allLabel: string,
  availableWidth: number,
  measureText: TextMeasurer,
  suffixGapWidth = 0
): SelectionSummary {
  const labels = selectedOptions.map(option => option.label);
  if (labels.length === 0) {
    return {
      labelsText: allLabel,
      ariaText: allLabel,
      allowLabelTruncation: false,
    };
  }

  const ariaText = labels.join(', ');
  if (availableWidth <= 0) {
    const remaining = labels.length - 1;
    return {
      labelsText: labels[0],
      overflowText: remaining > 0 ? `+${remaining} more` : undefined,
      ariaText,
      allowLabelTruncation: true,
    };
  }

  for (let visibleCount = labels.length; visibleCount >= 1; visibleCount -= 1) {
    const labelsText = labels.slice(0, visibleCount).join(', ');
    const remaining = labels.length - visibleCount;
    const overflowText = remaining > 0 ? `+${remaining} more` : undefined;
    const requiredWidth =
      measureText(labelsText) +
      (overflowText ? suffixGapWidth + measureText(overflowText) : 0);

    if (requiredWidth <= availableWidth) {
      return {
        labelsText,
        overflowText,
        ariaText,
        allowLabelTruncation: false,
      };
    }
  }

  const remaining = labels.length - 1;
  return {
    labelsText: labels[0],
    overflowText: remaining > 0 ? `+${remaining} more` : undefined,
    ariaText,
    allowLabelTruncation: true,
  };
}
